import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Checkbox, IconButton } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        margin: '70px auto 20px auto',
        maxWidth: '100%',
        borderBottom:'1px solid rgba(0,0,0,0.1)',
        paddingBottom:20,
    },
    content: {
        position: 'relative',
        '@media (max-width:550px)': {
            textAlign:'center',
            width:'100%',
        },
    },
    title: {
        fontSize: 30,
        fontWeight: 700,
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        right: '50%',
    },
    tagItem: {
        display: 'flex',
        alignItems: 'center',
        border:'1px solid rgb(177, 4, 31)',
        borderRadius:8,
        paddingLeft:20
    },
    deleteButton: {
        color: 'rgb(177, 4, 31)', // رنگ دلخواه
    },
}));

export default function Index({ tags  , setTags}) {

    const classes = useStyles();



    const handleDelete = () => {
        setTags(null)

    };

    return (
        <div className={classes["root"]}>
            <div className={classes['content']}>
                <div className={classes['line']} />
                <h3 className={classes['title']}>
                    آخرین مقالات و اخبار
                </h3>
            </div>
            <div>
                {
                    tags&&(
                        <div  className={classes.tagItem}>
                        <span>{tags?.name}</span>
                        <IconButton onClick={() => handleDelete(tags)}   className={classes.deleteButton} >
                            <DeleteIcon />
                        </IconButton>
                    </div>
                    )
                }
      
            
            </div>
        </div>
    );
}
